// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1407":"198d2240","1450":"198d2240","2453":"164f0e60","2929":"0ef5129e","6458":"cc14a32f","7940":"60f19c7e"}[chunkId] + ".chunk.css";
};